/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityStcModel
 */
export interface EligibilityStcModel {
    /**
     * Code identifying the service type (e.g. '30' for Health Benefit Plan Coverage)
     * @type {string}
     * @memberof EligibilityStcModel
     */
    eligibility_stc_code?: string;
    /**
     * Human readable name of the service type
     * @type {string}
     * @memberof EligibilityStcModel
     */
    eligibility_stc_name?: string;
}

/**
 * Check if a given object implements the EligibilityStcModel interface.
 */
export function instanceOfEligibilityStcModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EligibilityStcModelFromJSON(json: any): EligibilityStcModel {
    return EligibilityStcModelFromJSONTyped(json, false);
}

export function EligibilityStcModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityStcModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eligibility_stc_code': !exists(json, 'eligibility_stc_code') ? undefined : json['eligibility_stc_code'],
        'eligibility_stc_name': !exists(json, 'eligibility_stc_name') ? undefined : json['eligibility_stc_name'],
    };
}

export function EligibilityStcModelToJSON(value?: EligibilityStcModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eligibility_stc_code': value.eligibility_stc_code,
        'eligibility_stc_name': value.eligibility_stc_name,
    };
}

